import { DataValidator, IsString, Required, transformKeys } from "@/utils/type-vaildator";
import api, { apiV2 } from "./api";

// 图生视频并生成数字人 请求参数
export interface ImageToVideoRequest {
  user_id?: string;
  actor_name: string;
  actor_pic: string;
  audio_name: string;
  sample_audio_url: string;
  point?: number;
}

// 图生视频并生成数字人 接口参数
export interface ImageToVideoProps {
  userId?: string;
  actorName: string;
  actorPic: string;
  audioName: string;
  sampleAudioUrl: string;
  point?: number;
}

// 图生视频并生成数字人 响应参数
export interface imageToVideoResponse {
  message: string;
  status: string;
  template_id: string;
}

export class ImageToVideoData {
  @Required("message cannot be empty")
  @IsString("message must be a string")
  message: string;

  @Required("status cannot be empty")
  @IsString("status must be a string")
  status: string;

  @Required("templateId cannot be empty")
  @IsString("templateId must be a string")
  templateId: string;
}

const transformAndValidateData = (
  response: imageToVideoResponse
): ImageToVideoData => {
  const transformedData = transformKeys(response);

  try {
    const mainData = DataValidator.validateOrThrow(
      transformedData,
      ImageToVideoData
    );
    return mainData;
  } catch (error) {
    console.error("Audio data validation failed:", error.message);
    throw error;
  }
};

/** 图生视频并生成数字人 */
export const imageToVideo = async (props: ImageToVideoProps) => {
  const params: ImageToVideoRequest = {
    user_id: props.userId,
    actor_name: props.actorName,
    actor_pic: props.actorPic,
    audio_name: props.audioName,
    sample_audio_url: props.sampleAudioUrl,
    point: props.point,
  };
  const res = await apiV2.post<imageToVideoResponse>('/video/image-to-video', params);
  return transformAndValidateData(res.data);
}
